define('commons/timezone-selector',['jquery'], function($) {

    var TimeZoneSelector = function(container, actualTimezone, timezones, options) {
        this.settings = $.extend({}, options);

        var $container = $(container);
        $container.append('<label for="regions">Timezone</label>');
        $container.append('<select class="regions"></select>');
        $container.append('<select class="cities"></select>');
        $container.append('<input type="hidden" id="timezone-field" name="' + this.settings.fieldName + '" value="' + actualTimezone + '" />');

        this.regionsSelect = $container.find("select.regions");
        this.citiesSelect = $container.find("select.cities");
        this.timeZoneField = $container.find('#timezone-field');
        this.timezones = timezones;

        var extractRegion = function(timezone) {
            return timezone.split('/')[0];
        };

        var extractCity = function(timezone) {
            var parts = timezone.split('/');
            if (parts.length > 1) {
                return timezone.split('/')[1].replace(/_/g, ' ');
            }
            return null;
        };

        for (var region in timezones) {
            var option;
            if (region === extractRegion(actualTimezone)) {
                option = '<option selected="selected">' + region + '</option>';
            } else {
                option = '<option>' + region + '</option>';
            }
            this.regionsSelect.append(option);
        }

        this.actualCity = extractCity(actualTimezone);
        this.actualRegion = extractRegion(actualTimezone);

        this._selectCity();

        $(this.regionsSelect).change($.proxy(function(event) {
            this.actualRegion = $(event.currentTarget).val();
            this._selectCity();
            this._buildTimeZoneID();
        }, this));

        $(this.citiesSelect).change($.proxy(function(event) {
            this.actualCity = $(event.currentTarget).val();
            this._buildTimeZoneID();
        }, this));
    };

    TimeZoneSelector.prototype._buildTimeZoneID = function() {
        var timezone = this.actualRegion;
        if (this.actualCity !== null) {
            timezone += '/' + this.actualCity.replace(/ /g, '_');
        }
        this.timeZoneField.val(timezone);
    };

    TimeZoneSelector.prototype._selectCity = function() {
        var actualRegionCities = this.timezones[this.actualRegion];

        this.citiesSelect.empty();
        var length = (actualRegionCities == null) ? 0 : actualRegionCities.length;

        if (length > 0) {
            var found = false;
            for (var i = 0; i < length; i++) {
                var option;
                if (actualRegionCities[i] === this.actualCity) {
                    option = '<option selected="selected" value="' + actualRegionCities[i] + '">' + actualRegionCities[i] + '</option>';
                    found = true;
                } else {
                    option = '<option value="' + actualRegionCities[i] + '">' + actualRegionCities[i] + '</option>';
                }
                this.citiesSelect.append(option);
            }
            this.citiesSelect.show();
            this.actualCity = found ? this.actualCity : actualRegionCities[0];
        } else {
            this.actualCity = null;
            this.citiesSelect.hide();
        }
    };
    
    return TimeZoneSelector;

});
